module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-3.7e68628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-3.jpg
// module id = ym1B
// module chunks = 1